<template>
  <div class="gs-app gv-engagement">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <div class="w-full gv-engagement__content">
      <v-wait for="video">
        <half-circle-spinner
          style="display: block; margin: 0 auto"
          :animation-duration="1000"
          :size="60"
          color="#3d4852"
          slot="waiting"
        />

        <div id="funnels-list-view" class="mt-4 gv-engagement__table-shell">
          <!-- v-if="funnels.length" -->
          <v-client-table
            ref="funnelsTable"
            :data="analyticsData"
            :columns="videosTableColumns"
            :options="videosTableOptions"
            class="bg-white text-center rounded border border-grey-300 gv-engagement__table"
            :key="tableComponentKey"
            v-if="rerenderComponent"
          >
            <!--  <div slot="name" slot-scope="props">

                        </div>

                        <div slot="description" slot-scope="props" class="border border-grey-100 hover:border-white w-12 text-center ">

                        </div>
                        <div slot="video_source" slot-scope="props">

                        </div>
                        <div slot="created_at" slot-scope="props">

                        </div> -->
          </v-client-table>
        </div>
      </v-wait>
    </div>
  </div>
</template>

<style>
.dropdown-toggle {
  background-image: none !important;
  border: 1px solid dodgerblue !important;
  border-radius: 30px;
}

.dropdown-toggle:hover {
  background: transparent;
}
</style>

<style>
.gv-engagement__content {
  padding: 24px;
}

.gv-engagement__table-shell {
  overflow-x: auto;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gv-engagement__table {
  border: 0 !important;
  border-radius: var(--gs-radius-lg);
}

@media (max-width: 640px) {
  .gv-engagement__content {
    padding: 16px;
  }
}
</style>

<script>
import Video from '@/models/Video';
import Swal from 'sweetalert2';
import router from '@/router';
import themeConfig from '@/theme/themeConfig.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Notify from '@groovepages/gd-lib/notify';
import Snapshot from '@/assets/images/icons/Focus.svg';
import store from '@/state';
import VideoEdit from '@/models/VideoEdit';
import Analytic from '@/models/Analytic';
import Engagement from '@/models/VideoEngagement';

import { required, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  middleware: 'auth',

  metaInfo() {
    return { title: 'My Product Funnels' };
  },
  data() {
    return {
      rerenderComponent: true,
      tableComponentKey: 0,
      funnel: null,
      funnels: [],
      video: null,
      analyticsData: [],
      itemsPerPage: 5,
      model: {
        name: '',
        description: '',
        edit_name: '',
        edit_description: '',
        edit_id: null,
      },
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      optinCount: 0,
      optinItration: [],
      //  videosTableColumns: ['Video Name','Impression','Place','Date','Visitors','Complete', 'Average Time'],
      videosTableColumns: ['id', 'optinCount', 'click_count'],
      videosTableOptions: {
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        sortable: ['id', 'optinCount', 'click_count'],
        headings: {
          id: () => this.$t('frontend_groovevideo_engagement_heading_id'),
          optinCount: () =>
            this.$t('frontend_groovevideo_engagement_heading_optin_count'),
          click_count: () =>
            this.$t('frontend_groovevideo_engagement_heading_click_count'),
        },
        filterByColumn: false,
        filterable: false,
        perPage: 10000,
        rowClassCallback(myRowObject) {
          return 'hover:bg-grey-50 funnelRow';
        },
      },
      selectedFunnelProducts: [],
      videoData: [],
      innrLoop: [],
    };
  },
  validations: {
    model: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20),
      },
      description: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(40),
      },
      edit_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20),
      },
      edit_description: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
    },
  },
  components: {
    Loading,
    Snapshot,
  },
  methods: {
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
  async created() {},
  async mounted() {
    this.showLoader();
    this.videoData = await Engagement.$get();
    this.analyticsData = this.videoData;
    this.hideLoader();
  },
  computed: {
    admin() {
      return this.$store.state.user.admin;
    },
  },
};
</script>

<style lang="scss">
.dropdown-button-container {
  display: flex;
  align-items: center;

  .btnx {
    border-radius: 5px 0px 0px 5px;
  }

  .btn-drop {
    border-radius: 0px 5px 5px 0px;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
  }
}
</style>

<style lang="scss">
#funnels-list-view,
#products-list-view {
  .VueTables--client table {
    overflow: auto !important;
  }

  .VueTables__search-field {
    margin-bottom: 10px;
  }

  .VueTables__heading {
    color: #8f92ab;
  }

  .VueTables__sort-icon {
    color: #8f92ab;
    margin-left: 8px;
  }

  td {
    font-weight: 200;
  }

  .VueTables__child-row-toggler--closed::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 7l-.707031.707031 6.125 6.125 1.875 1.875 1.875-1.875 6.125-6.125-.707031-.707031-6.125 6.125-1.167969 1.167969-1.167969-1.167969-6.125-6.125' /></svg>");
    padding-right: 3px;
    vertical-align: middle;
  }

  .VueTables__child-row {
    text-align: center;
    border-bottom: 1px solid #ddd;
    border-left: 5px solid #fd6481;
  }

  .VueTables__child-row-toggler--open::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 1044.3622l-.707031-.707 6.125-6.125 1.875001-1.875 1.875 1.875 6.125 6.125-.707032.707-6.125-6.125-1.167968-1.168-1.167969 1.168-6.125 6.125' transform='translate(0-1030.3622)'/></svg>");
    padding-right: 3px;
    vertical-align: middle;
  }

  .VueTables__table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
  }

  .VueTables__row {
    border-bottom: 1px solid #ddd;
  }

  .VueTables__table th,
  td {
    text-align: left;
    padding: 16px;
  }

  tr.VueTables__child-row > td {
    padding: 0px !important;
  }

  thead {
    border-bottom: 1px solid #ddd;
  }

  .vue-pagination-ad {
    text-align: center;
  }

  .VueTables__limit {
    display: none;
  }

  .VuePagination__count {
    display: none;
  }

  .expandIcon {
    display: none;
  }

  .funnelRow:hover .expandIcon {
    display: block !important;
  }
}
</style>
